var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-icon',{staticClass:"loader",class:_vm.componentClass,attrs:{"color":_vm.color}},[_vm._v("mdi-dots-circle")])
}
var staticRenderFns = []

export { render, staticRenderFns }